export default __webpack_public_path__ + "static/media/file.08bb6303.svg";